import * as React from 'react';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import InboxRulesFull from './components/InboxRulesFull';
import isInboxRuleEditValid from './utils/isInboxRuleEditValid';
import isInboxRuleOptionEditState from './actions/helpers/isInboxRuleOptionEditState';
import resetInboxRuleEdit from './actions/resetInboxRuleEdit';
import saveInboxRuleEdit from './actions/saveInboxRuleEdit';
import { Option } from 'owa-options-core';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

let InboxRulesOption: Option = {
    key: 'inboxRules',
    titleStringKey: 'optionTitle_inboxRules',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_inboxRules',
    fullOptionFormSettings: {
        render: () => <InboxRulesFull />,
        isDirty: () => isInboxRuleOptionEditState(),
        onSave: () => saveInboxRuleEdit(),
        onDiscard: () => resetInboxRuleEdit(),
        disableSave: () => !isInboxRuleEditValid(),
        hideSaveDiscard: () => {
            return !isInboxRuleOptionEditState();
        },
    },
    isHidden: () => {
        return !getUserConfiguration().SegmentationSettings.Rules || IsShadowMailboxUser();
    }, // Hide if Rules is disabled by admin
    allowedOptionKeys: ['EditInboxRule', 'InboxRules'],
};

export default InboxRulesOption;
